import { Injectable } from '@angular/core';
import { AppState } from '@mode/legacy/types-app-state';
import { Action, Store } from '@ngrx/store';
import { GenericLegacyRxStoreService } from './generic-legacy-rx-store.service';

@Injectable({
  providedIn: 'root',
})
export class LegacyAppStateStoreService extends GenericLegacyRxStoreService<AppState, Action> {
  constructor(store: Store<AppState>) {
    super(store);
  }
}
